<template>
    <div>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">
                Name
            </v-col>
            <v-col cols="6" sm="4">{{ monster.name }}</v-col>
            <v-col cols="6" sm="2" class="font-weight-medium">Source</v-col>
            <v-col cols="6" sm="4">{{ monster.source }}</v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">Hits</v-col>
            <v-col cols="6" sm="4">{{ hits }}</v-col>
            <v-col cols="6" sm="2" class="font-weight-medium">Race</v-col>
            <v-col cols="6" sm="4">{{ race }}</v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">Dis/Con</v-col>
            <v-col cols="6" sm="4">{{ dismissControl }}</v-col>
            <v-col cols="6" sm="2" class="font-weight-medium">Pattern</v-col>
            <v-col cols="6" sm="4">{{ pattern }}</v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">Intelligence</v-col>
            <v-col cols="6" sm="4">{{ intelligence }}</v-col>
            <v-col cols="6" sm="2" class="font-weight-medium">Strikes For</v-col>
            <v-col cols="6" sm="4">{{ strikesFor }}</v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">Immunities</v-col>
            <v-col cols="6" sm="10">{{ immunities }}</v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" sm="2" class="font-weight-medium">Abilities</v-col>
            <v-col cols="6" sm="10">{{ abilities }}</v-col>
        </v-row>
        <div class="float-right">
            <router-link :to="{ name: 'readMonster', params: { id: monster.keyId } }" :title="monster.name">
                See More...
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MonsterSummary',
    props: {
        monster: {
            type: Object,
            required: true,
        },
    },
    computed: {
        hits() {
            if (!this.monster) return ''
            return `${this.monster.hits} + ${this.monster.armour}`
        },
        dismissControl() {
            if (!this.monster) return ''
            return this.monster.dismissControl
        },
        race() {
            if (!this.monster) return ''
            return `${this.monster.race} (Weak: ${this.monster.elementalWeakness || 'Unknown'})`
        },
        pattern() {
            if (!this.monster) return ''
            return this.monster.patternType
        },
        intelligence() {
            if (!this.monster) return ''
            return this.monster.intelligence
        },
        strikesFor() {
            if (!this.monster) return ''
            return this.monster.strikesFor
        },
        immunities() {
            if (!this.monster) return ''
            return this.monster.immunities
        },
        abilities() {
            if (!this.monster) return ''
            return `${this.monster.abilityOne} ${this.monster.abilityTwo} ${this.monster.abilityThree}`
        },
    },
}
</script>
